import { Box, Typography, Paper } from '@mui/material';
import { GSTHeadCells } from '../../newReports/data';
import { useEffect, useRef } from 'react';
import { useReportContext } from '../ReportContext';
import { useSearchParams, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ListEwayBill from '../../eWayBill/listEwayBill';

const GSTReports = () => {
  const { updateReportData } = useReportContext();
  const [searchParams] = useSearchParams();
  const { id: reportId } = useParams();
  const previousReportIdRef = useRef(reportId);
  const dashboardData = useSelector((state) => state?.DashboardDataReducer);
  const { startTimeStamp, endTimeStamp } = dashboardData?.report;

  // Clear data when report ID changes
  useEffect(() => {
    if (previousReportIdRef.current !== reportId && previousReportIdRef.current !== null) {
      // Report ID changed, clear data
    }
    previousReportIdRef.current = reportId;
  }, [reportId]);
  console.log(reportId, 'reportId');
  // Get selected account IDs from URL
  const idsParam = searchParams.get('ids');
  const selectedIds = idsParam
    ? decodeURIComponent(idsParam)
        .split(',')
        .filter(Boolean)
        .map((id) => id.trim())
    : [];

  // Check if account '004' (Eway Bill List) is selected
  const isEwayBillSelected = selectedIds.includes('004');

  return (
    <Box sx={{ width: '100%', maxWidth: '100%', overflowX: 'hidden' }}>
      {
        isEwayBillSelected && <ListEwayBill startTimeStamp={startTimeStamp} endTimeStamp={endTimeStamp} />
        // ) : (
        //   <Paper sx={{ p: 3 }}>
        //     <Typography variant="h4" gutterBottom>
        //       GST Reports
        //     </Typography>
        //     <Typography variant="body1" color="text.secondary">
        //       Please select "Eway Bill List" from the header to view the report
        //     </Typography>
        //   </Paper>
        // )
      }
    </Box>
  );
};

export default GSTReports;
